import { curry } from 'ramda';
import getValidLangKey from './getValidLangKey';

export default curry((langs, defaultLangKey, url) => {
  const langKey = url.split('/')[1];
  return getValidLangKey(langs, defaultLangKey, langKey);
});
